export default __webpack_public_path__ + "static/media/certificate_altrom_en.f12d0993.svg";